export default {"src":"/_next/static/media/heart.61c7ccff.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};